import { Loader } from "@googlemaps/js-api-loader";
import helpers from "../modules/helpers";

window.recaptchaOnloadCallback = function () {
  grecaptcha.render("recaptcha_element", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: templateContacts.challange,
  });
};

const dom_map = $(".contacts-map__el");
const contact_form = $("#contact-form");
const templateContacts = {
  init: function () {
    if (dom_map.length) {
      this.map.init();
    }
    if (contact_form.length) {
      contact_form.on("submit", function (e) {
        e.preventDefault();
        $(".error", this).removeClass("error");
        if (helpers.validate($(this))) {
          window.grecaptcha.execute();
        }
      });
    }
  },

  challange: function (token) {
    if (token) {
      templateContacts.submit(token);
    }
    window.grecaptcha.reset();
  },

  map: {
    lat: false,
    lng: false,
    pin: false,
    zoom: 17,

    init: function () {
      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        templateContacts.map.start();
      });
    },

    start() {
      google.maps.Map.prototype.setCenterWithOffset = function (
        latlng,
        offsetX,
        offsetY
      ) {
        let map = this;
        let ov = new google.maps.OverlayView();
        ov.onAdd = function () {
          let proj = this.getProjection();
          let aPoint = proj.fromLatLngToContainerPixel(latlng);
          aPoint.x = aPoint.x + offsetX;
          aPoint.y = aPoint.y + offsetY;
          map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
        };
        ov.draw = function () {};
        ov.setMap(this);
      };
      templateContacts.map.render_map();
    },

    render_map: function () {
      let self = this;
      self.lat = dom_map.data("lat");
      self.lng = dom_map.data("lng");
      let center = new google.maps.LatLng(self.lat, self.lng);
      if (dom_map.data("zoom")) {
        self.zoom = parseInt(dom_map.data("zoom"));
      }

      if (dom_map.data("pin")) {
        self.pin = dom_map.data("pin");
      }

      let map_options = {
        zoom: self.zoom,
        center: center,
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#1d1a27" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [
              { color: "#ffffff" },
              { lightness: -15 },
              { visibility: "on" },
              { weight: 0.5 },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#aaaaaa" }, { lightness: 20 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#aaaaaa" }, { lightness: 15 }, { weight: 1 }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#e6e6e6" }, { lightness: 20 }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#dedede" }, { lightness: 21 }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#aaaaaa" }, { lightness: 20 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#aaaaaa" }, { lightness: 15 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#aaaaaa" }, { lightness: 30 }],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#aaaaaa" }, { lightness: 15 }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#d0d0d0" }, { lightness: 15 }],
          },
        ],
      };

      const map = new google.maps.Map(dom_map[0], map_options);
      const bounds = new google.maps.LatLngBounds();

      map.markers = [];
      let activeBubble = -1;

      $(".contacts-map__nav").each(function (index) {
        let center = new google.maps.LatLng(
          $(this).data("lat"),
          $(this).data("lng")
        );
        let marker_options = {
          position: center,
          map: map,
          animation: google.maps.Animation.DROP,
        };
        if ($(this).data("pin")) {
          marker_options.icon = $(this).data("pin");
        }
        let marker = new google.maps.Marker(marker_options);
        map.markers.push(marker);
        bounds.extend(center);

        let infoBubble = new google.maps.InfoWindow({
          content: $("[data-item=" + index + "]").html(),
          arrowSize: 50,
          arrowPosition: 50,
          arrowStyle: 0,
          shadowStyle: 0,
          padding: 0,
          borderRadius: 0,
          borderWidth: 0,
          backgroundClassName: "google__popup",
          backgroundColor: "transparent",
          maxWidth: 180,
          minWidth: 180,
          closeSrc: dom_map.data("close"),
        });

        marker.addListener("click", function () {
          if (activeBubble != -1) activeBubble.close();
          activeBubble = infoBubble;
          infoBubble.open(map, marker);
        });
      });

      map.fitBounds(bounds);
    },
  },

  submit: function (token) {
    const formData = new FormData($("#contact-form")[0]);
    formData.append("contact-token", token);

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: function () {
        contact_form.addClass("loading");
        contact_form.find("button").addClass("loading");
        contact_form.find(".form__status").addClass("hidden");
      },
      success: function (response) {
        contact_form.removeClass("loading");
        contact_form.find("button").removeClass("loading");
        if (response.success) {
          contact_form.find(".errors-wrap").remove();
          contact_form.find(".form__status").removeClass("error");
          if (response.data.redirect) {
            contact_form.find("input, textarea").blur();
            window.location.replace(response.data.redirect);
          } else {
            contact_form[0].reset();
            grecaptcha.reset();
          }
        } else {
          contact_form
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      },
    });
  },
};

export default templateContacts;
